import { FC } from "react";

import Loader from "@shared-containers/Loader";

import { CircularProgress } from "@mui/material";
import { Flex } from "@shared-ui-components/Flex";
import Colors from "@constants/Colors";
import NotificationCard from "./NotificationCard";
import NotificationEmptyState from "./NotificationEmptyState";
import { CustomLoadMoreButton } from "./style";
import { NotificationEmptyStateCard } from "./NotificationEmptyState/style";

interface NotificationTableType {
  notificationList: NotificationDataType[];
  handleViewDetailsButton: (
    propertyShortName: string,
    checkNo: string,
    notificationId: string
  ) => void;
  loading: LoadingType;
  handleLoadMore: () => void;
  showLoadMore: boolean;
}
const NotificationTable: FC<NotificationTableType> = ({
  notificationList,
  handleViewDetailsButton,
  loading,
  handleLoadMore,
  showLoadMore,
}) => {
  if (loading.mainLoader)
    return (
      <NotificationEmptyStateCard isNotification>
        <Loader />
      </NotificationEmptyStateCard>
    );
  if (notificationList?.length > 0) {
    return (
      <>
        {notificationList?.map((i: NotificationDataType) => (
          <NotificationCard
            notificationId={i?.id}
            time={i?.time}
            propertyShortName={i?.property_short_name}
            rvcName={i?.rvc_name}
            type={i?.type}
            checkNo={i?.check_no}
            unread={i?.unread}
            handleViewDetailsButton={handleViewDetailsButton}
          />
        ))}
        {showLoadMore ? (
          <CustomLoadMoreButton onClick={handleLoadMore}>
            <Flex>
              <div className="buttonText">Load More</div>
              {loading.loadMoreLoader && (
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  style={{ paddingLeft: 25 }}
                >
                  <CircularProgress
                    size={25}
                    sx={{
                      color: Colors.white,
                    }}
                  />
                </Flex>
              )}
            </Flex>
          </CustomLoadMoreButton>
        ) : null}
      </>
    );
  }
  return <NotificationEmptyState />;
};

export default NotificationTable;
